export default "__VITE_ASSET__DziPkFI2__"